import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import NestedUserHeader from '../../../component/reusable/NestedUserHeader';
import AddVendorForm from '../../../component/allvendor/AddVendorForm';
import EditVendorForm from '../../../component/allvendor/EditVendorForm';
import { getAllAdminThunk } from '../../../redux/admin/adminSlice';
import { exportManufacturerThunk } from '../../../redux/manufacturer/getAllManufacturerSlice';
import { getVendorDetailsThunk } from '../../../redux/vendor/vendorSlice';
import { useParams } from 'react-router-dom';

const EditVendor = () => {

  const dispatch = useDispatch();
  const { id } = useParams()

  useEffect(() => {
    dispatch(getVendorDetailsThunk(id))

    dispatch(getAllAdminThunk())
    dispatch(exportManufacturerThunk())
  }, []);

  
  
  
  return (
    <div >
      <NestedUserHeader 
        index="Edit Vendor"
        root="Dashboard"
        buttonText={'Back to list'}/>
      <EditVendorForm />
    </div>
  );

};

export default EditVendor;
